import { useState, useEffect } from 'react'

export const useEverSelectedCategories = (
  selectedCategoryIds: number[] | null
): [number[] | null, (v: number[] | null) => void] => {
  const [everSelectedCategoryIds, setEverSelectedCategoryIds] = useState<number[] | null>(null)

  useEffect(() => {
    if (!selectedCategoryIds) return

    selectedCategoryIds?.forEach(id => {
      if (!everSelectedCategoryIds) {
        setEverSelectedCategoryIds([id])
        return
      }

      if (!everSelectedCategoryIds.includes(id)) {
        setEverSelectedCategoryIds([...everSelectedCategoryIds, id])
      }
    })
  }, [everSelectedCategoryIds, selectedCategoryIds])

  return [everSelectedCategoryIds, setEverSelectedCategoryIds]
}
